import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux/storeConfig/store";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router } from "react-router-dom";

import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import "animate.css";

ReactDOM.render(
  <Provider store={store}>
    <ToastContainer autoClose={2500} position="top-right" closeButton={false} />
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);
